import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { DefaultText, IconButton } from '@guryou/html-components';
import { Menu as MuiMenu, MenuItem as MuiMenuItem } from '@material-ui/core';
import { DownloadIcon } from '../icons';
const DownloadsMenu = /*#__PURE__*/forwardRef(({
  extraButton,
  paidPackage,
  onPrintClick
}, ref) => {
  const {
    t
  } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // onPrintClick is supplied when the parent (MultipleItemsContainer) manages the print
  // target's lifecycle itself (lazyPrint) — otherwise fall back to printing straight from ref.
  const legacyHandlePrint = useReactToPrint({
    content: () => ref.current
  });
  const handlePrint = onPrintClick || legacyHandlePrint;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    marginLeft: !extraButton && 'auto',
    icon: DownloadIcon,
    label: paidPackage ? t('GENERAL.download') : t('BUSINESS_PLANS.insufficientPlanText'),
    onClick: handleClick,
    tooltip: paidPackage ? t('GENERAL.download') : t('BUSINESS_PLANS.insufficientPlanText')
  }), /*#__PURE__*/React.createElement(MuiMenu, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: handleClose,
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(MuiMenuItem, {
    disabled: !paidPackage,
    onClick: () => document.querySelector('[data-testid="Download CSV-iconButton"]').click()
  }, /*#__PURE__*/React.createElement(DefaultText, {
    marginLeft: 1
  }, t('GENERAL.csv'))), /*#__PURE__*/React.createElement(MuiMenuItem, {
    disabled: !paidPackage,
    onClick: handlePrint
  }, /*#__PURE__*/React.createElement(DefaultText, {
    marginLeft: 1
  }, t('GENERAL.pdf')))));
});
export default DownloadsMenu;